<template>
  <a-modal
    :open="open"
    centered
    :header="null"
    :width="650"
    wrapClassName="transaction-modal"
    @cancel="handleCancel"
  >
    <div class="container">
      <section>
        <h4>
          {{
            isApprovedTransaction ? "Tu pago se realizó con éxito 💰" : "¿Tu pago fue rechazado? 😰"
          }}
        </h4>

        <img src="../../assets/merchant.png" alt="merchant" />

        <p v-if="isApprovedTransaction">
          Tu recarga ha sido procesada con éxito, y ahora tu plataforma está lista para explorar
          nuevas fronteras.
          <br />
          <br />
          Continuemos juntos este viaje galáctico, sacando el máximo provecho a tu ambiente de
          trabajo.
        </p>

        <p v-else>
          Te recomendamos verificar si cuentas con suficiente saldo en tu cuenta. Si necesitas
          asistencia adicional, no dudes en comunicarte con nosotros haciendo
          <a :href="supportUrl" target="_blank" rel="noopener noreferrer">click aquí</a> o
          escríbenos a nuestro correo <strong>soporte@scorecloud.pe</strong> y te atenderemos lo
          antes posible.
        </p>
      </section>
    </div>

    <template #footer>
      <footer class="footer">
        <a-button @click="handleCancel">Aceptar</a-button>
      </footer>
    </template>
  </a-modal>
</template>

<script setup>
import { computed } from "vue";

import { supportUrl } from "@/app/common/components/organisms/TheSidebar/items";

const props = defineProps({ open: Boolean, state: String });

const emit = defineEmits(["update:open"]);

const isApprovedTransaction = computed(() => props.state === "success");

const handleCancel = () => {
  emit("update:open", false);
};
</script>

<style lang="sass" scoped>
:global(.transaction-modal .ant-modal-content)
  overflow: hidden

.container
  height: 100%
  width: 100%
  display: flex
  justify-content: center
  align-items: center
  flex-direction: column
  margin: 0 auto
  padding: 40px 0
  position: relative

  &::before
    content: ""
    background-image: url("../../assets/planets-background.png")
    background-position: center
    background-size: contain
    background-repeat: no-repeat
    position: absolute
    height: 120%
    width: 125%
    top: 40px

h4
  font-weight: 600
  font-size: 38px
  color: $text-primary

p
  font-weight: 400
  font-size: 20px
  color: $gray-8
  position: relative
  max-width: 80%
  margin: 0 auto
  z-index: 2

img
  height: 140px
  margin-bottom: 20px

section
  text-align: center

.footer
  width: 100%
  text-align: center
</style>
